const capitalizeFirstLetter = (word: string): string =>
  word.charAt(0).toUpperCase() + word.slice(1)

function formatSnakeCaseLabel(value?: string): string {
  if (!value) return '--'

  const words = value.split('_')
  const sentence = words.join(' ')
  return sentence.charAt(0).toUpperCase() + sentence.slice(1).toLowerCase()
}
export { capitalizeFirstLetter, formatSnakeCaseLabel }
